import { render, staticRenderFns } from "./InstallmentFormNicheView.vue?vue&type=template&id=1385696e&"
import script from "./InstallmentFormNicheView.vue?vue&type=script&lang=js&"
export * from "./InstallmentFormNicheView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports